import React from 'react';
import type { LicensePaymentStatus } from '../../api/license.api';
import styles from './LicenseLockedScreen.module.css';

interface Props {
  status: LicensePaymentStatus;
  onLogout: () => void;
}

/**
 * 라이선스 잠금 화면 — paymentStatus === 'LOCKED' 일 때 페이지 자체 차단
 * 무료 체험 48시간 종료 + 입금 미확인 시 자동 잠금된 상태.
 */
function copyToClipboard(text: string, label: string): void {
  if (typeof navigator !== 'undefined' && navigator.clipboard) {
    navigator.clipboard.writeText(text).then(() => {
      window.alert(`${label} 복사됨: ${text}`);
    });
  }
}

export default function LicenseLockedScreen({ status, onLogout }: Props) {
  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <div className={styles.iconBox}>
          <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <rect x="3" y="11" width="18" height="11" rx="2"/>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
          </svg>
        </div>
        <h1 className={styles.title}>라이선스 결제 대기</h1>
        <p className={styles.message}>
          무료 체험 기간(48시간)이 종료되었습니다.<br />
          서비스 계속 이용을 위해 라이선스 입금이 필요합니다.
        </p>

        <div className={styles.infoBox}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>은행</span>
            <span className={styles.infoValue}>{status.paymentInfo.bankName}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>계좌번호</span>
            <button
              type="button"
              className={styles.copyBtn}
              onClick={() => copyToClipboard(status.paymentInfo.accountNumber, '계좌번호')}
            >
              {status.paymentInfo.accountNumber}
              <span className={styles.copyHint}>복사</span>
            </button>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>예금주</span>
            <span className={styles.infoValue}>{status.paymentInfo.accountHolder}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>금액</span>
            <span className={styles.infoValueLarge}>
              {status.paymentInfo.amount.toLocaleString()}원
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>입금자명</span>
            <button
              type="button"
              className={styles.copyBtn}
              onClick={() =>
                copyToClipboard(status.paymentInfo.depositorNameHint, '입금자명')
              }
              title="매장명과 정확히 일치하도록 입금"
            >
              {status.paymentInfo.depositorNameHint}
              <span className={styles.copyHint}>복사</span>
            </button>
          </div>
        </div>

        <div className={styles.helpText}>
          입금 후 영업일 1일 이내 라이선스가 자동 활성화됩니다.<br />
          확인이 늦어질 경우 고객센터로 연락 부탁드립니다.
        </div>

        <div className={styles.contactRow}>
          <a href="tel:010-3000-6253" className={styles.contactLink}>
            전화 010-3000-6253
          </a>
          <a href="mailto:mansuk@sangsangnode.co.kr" className={styles.contactLink}>
            메일 mansuk@sangsangnode.co.kr
          </a>
        </div>

        <button type="button" className={styles.logoutBtn} onClick={onLogout}>
          로그아웃
        </button>
      </div>
    </div>
  );
}
